<template>
    <div class="stock_wrap">
        <!-- 头部信息 -->
        <div class="header_wrap">
            <div class="investment_name">
                <div v-if="stockInfo.g_name">
                    <h4 v-if="stockInfo.g_name.indexOf('的组合')>-1">{{stockInfo.g_name}}</h4>
                    <h4 v-else>{{stockInfo.g_name}}的组合</h4>
                </div>
                <div><button @click.stop.prevent="$downapppop.open('关注')">关注</button></div>
            </div>
            <div class="profit_wrap">
                <div class="all_profit">
                    <span>{{ stockInfo.profit_rate_t || "-" }}%</span>
                    <p>总收益率</p>
                </div>
                <div class="day_profit left_line">
                    <span>{{ stockInfo.profit_rate_d || "-" }}%</span>
                    <p>日收益</p>
                </div>
                <div class="month_profit left_line">
                    <span>{{ stockInfo.profit_rate_m || "-" }}%</span>
                    <p>近1月</p>
                </div>
            </div>
            <div class="profit_box">
                <template v-if="match_id">
                    <div class="profit_left">
                        <p class="profit_left_p3" v-if="stockInfo.is_show_match_rate">
                            <span>{{stockInfo.show_match_rate_title}}</span>
                            <span>{{stockInfo.profit_rate_match}}</span>
                            <span v-if="stockInfo.match_time">（{{stockInfo.match_time}}）</span>
                        </p>
                    </div>
                    <div class="profit_right">
                        <p>大赛排名 {{match_info && match_info.profit_rank || '--'}}</p>
                    </div>
                </template>
                <template v-else>
                    <div class="profit_left">
                        <p class="profit_left_p3">总收益跑赢了{{stockInfo.profit_rank || "0.00"}}%的组合</p>
                    </div>
                    <div class="profit_right">
                        <p>{{stockInfo.follow_num}}人关注</p>
                    </div>
                </template>
                
            </div>
        </div>

        <!-- 主理人信息 -->
        <div class="pri_person_info">
            <div class="person_avatar">
                <img :src="pageUserInfo.avatar">
            </div>
            <div class="person_info">
                <p class="person_info_name">主理人：{{pageUserInfo.nickname}}</p>
                <p class="person_info_brief">{{pageUserInfo.brief}}</p>
            </div>
        </div>


        <!-- 当前持仓 -->
        <div class="hold_position">
            <div class="hold_position_title">当前持仓</div>
            <div class="hold_position_header">
                <div>名称/代码</div>
                <div>现价/成本</div>
                <div>盈亏</div>
            </div>
            <ul>
                <li v-for="(item, index) in holdPositionList" :key="index">
                    <div class="stock_info">
                        <p class="stock_name">{{item.stock_name}}</p>
                        <span class="stock_code">{{item.stock_code}}</span>
                    </div>
                    <div class="stock_val">
                        <p class="stock_last">{{item.last_price}}</p>
                        <span class="stock_cost">{{item.cost_price}}</span>
                    </div>
                    <div class="stock_loss" :class="{ bind_red: item.income_balance > 0, bind_green: item.income_balance<0 }">
                        <p class="sotck_chg">{{item.income_balance}}</p>
                        <span class="stock_chg_pct">{{item.profit_rate}}</span>
                    </div>
                </li>
            </ul>
            <div class="hold_position_footer" v-if="holdPositionListLen > 5">
                <p><a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui" style="color: inherit;">查看更多持仓请下载app</a></p>
            </div>
        </div>

        <!-- 收益率走势 -->
        <div class="yield_trend">
            <div class="yield_trend_head">
                <div class="yield_trend_head_left">
                    <span class="yield_trend_head_left_title">收益率走势</span>
                    <span class="yield_trend_head_left_time">({{yidld_info && yidld_info.start_time}}创建)</span>
                </div>
                <div class="yield_trend_head_right" @click.stop.prevent="jumpDownloadPage">
                    <button>收益分析</button>
                </div>
            </div>
            <div>
                <div id="main_z" style="width: 100%; height: 275px;"></div>
            </div>

            <!-- 选股胜率 最大回撤 -->
            <div class="yield_trend_info">
                <span>选股胜率<em :style="{color: yidld_info && yidld_info.profit_rate_color}">{{yidld_info && yidld_info.user_profit_rate}}</em></span>
                <span>最大回撤<em :style="{color: yidld_info && yidld_info.back_profit_rate_color}">{{yidld_info && yidld_info.back_profit_rate}}</em></span>
            </div>

            <!-- 收益率类型 -->
            <div class="yield_trend_tabs">
                <button v-for="(item, index) in yield_tabs" :key="index" :class="{bind_this: yield_check == item.type}" @click.stop.prevent="checkYield(item.type)">{{ item.name }}</button>
            </div>
        </div>

        <!-- 仓配配置 -->
        <div class="chart_header">
            <div class="chart_header_left">
                <span class="chart_header_left_title">仓位配置</span>
            </div>
            <div class="chart_header_right" @click.stop.prevent="jumpDownloadPage">
                <button>详细仓位</button>
            </div>
        </div>
        <div id="canvas-holder">
            <div class="canvas-holder-left">
                <div id="main_c" style="width: 180px; height: 180px;"></div>
                <div class="chart_info"></div>
            </div>
            <div id="center_circle" style="width:70%;">
                <div v-for="(item, index) in chartList" :key="index">
                    <div class="center_circle_name">
                        <em :style="{
                            'background-color': colorList[index]
                        }"></em>
                        <span>{{ item.stock_name }}</span>
                    </div>
                    <div class="center_circle_rate">
                        <span>{{ item.stock_position }}</span>
                    </div>
                </div>
                <div v-if="chartEmpty && chartEmpty.length > 0">
                    <div class="center_circle_name">
                        <em :style="{
                            'background-color': '#f0f0f0'
                        }"></em>
                        <span>{{ chartEmpty[0].stock_name }}</span>
                    </div>
                    <div class="center_circle_rate">
                        <span>{{ chartEmpty[0].stock_position }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="openApp">
            <button><a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui" style="color: inherit;">打开APP查看持仓详情</a></button>
        </div>

        <!-- 最近调仓 -->
        <div class="warehouse">
            <div class="warehouse_head">
                <div class="warehouse_head_left">
                    <span class="warehouse_head_left_title">最近调仓</span>
                    <span class="warehouse_head_left_time" v-if="businessList && businessList.length > 0">[{{ businessList && timestampToTime(businessList[0].sort_time) }}]</span>
                </div>
                <div class="warehouse_head_right" @click.stop.prevent="jumpDownloadPage">
                    <button>全部记录</button>
                </div>
            </div>
            <div class="businessList_header">
                <div>名称/代码</div>
                <div>数量/成交价</div>
                <div>仓位变化/时间</div>
            </div>
            <div class="businessList_box">
                <div class="businessList_li" v-for="(item, index) in businessList" :key="index">
                    <div class="businessList_l">
                        <div class="businessList_l_type">
                            <span :class="[item.entrust_bs == 1 ? 'up' : 'down']">{{ item.entrust_bs == "1" ? "买" : "卖"
                            }}</span>
                        </div>
                        <div class="businessList_l_nc">
                            <p class="businessList_l_name">{{ item.stock_name }}</p>
                            <p class="businessList_l_code">{{ item.stock_code }}</p>
                        </div>
                    </div>
                    <!-- div class="itmedddd ddd ddddfddddddf dddf" -->
                    <div class="businessList_c">
                        <p :class="['businessList_c_c', item.entrust_bs == 1 ? 'up' : 'down']">{{ item.business_amount }}
                        </p>
                        <p class="businessList_c_a">{{ item.business_price }}</p>
                    </div>
                    <div class="businessList_r">
                        <p class="businessList_r_c">
                            <span>{{ item.stock_position }}%</span>
                            <em></em>
                            <span>{{ item.stock_position_2 }}%</span>
                        </p>
                        <p class="businessList_r_t">
                            <span>{{ item.desc_time }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 组合讨论 -->
        <div class="discuss">
            <div class="discuss_head">
                <div class="discuss_head_left">
                    <span class="discuss_head_left_title">组合讨论</span>
                </div>
            </div>
            <div>
                <li class="first_level_comment" data-type="first" v-for="(item, index) in commentList" :key="index">
                    <template v-if="item.l_id>0 && item.is_vip_service == 'yes'">
                        <a @click.stop.prevent="l_id_jump(item.l_id, item.user_medals_tail)">
                            <img :src="item.u_avatar">
                        </a>
                    </template>
                    <template v-else>
                        <a :href="user_url(item)">
                            <img :src="item.u_avatar">
                        </a>
                    </template>
                    <div class="live_comment_right">
                        <div class="comment_detail clearfix">
                            <p>
                                <template v-if="item.l_id>0 && item.is_vip_service == 'yes'">
                                    <a @click.stop.prevent="l_id_jump(item.l_id, item.user_medals_tail)">
                                        <span style="color:#2d64ba;" class="comment_uName">{{item.u_name}}</span>
                                    </a>
                                </template>
                                <template v-else>
                                    <a :href="user_url(item)">
                                        <span style="color:#2d64ba;" class="comment_uName">{{item.u_name}}</span>
                                    </a>
                                </template>
                            </p>
                            <div class="comment_detail_info">
                                <span style="float: none" class="comment_con comment_con_1" v-html="item.content"></span>
                            </div>
                            <div class="comment_reply_wrap" style="margin-bottom: 9px;">
                                <span style="float: left;margin-right: 0;color: #999999;padding: 0;height:16px;line-height: 16px">{{item.rec_time_desc}}</span>
                                <span  style="float: left;margin-left: 5px;margin-right: 5px;color: #999999;padding: 0;height:16px;line-height: 16px">·</span>
                                <a href="javascript:;" class="comment_reply" style="height:16px;line-height: 16px" @click.stop.prevent="replayFn(item, index, $event)">回复</a>
                                <a 
                                    href="javascript:;" 
                                    :class="['comment_point', 'c_likea' + item.id, {
                                        yizan: item.is_support == 'yes'
                                    }]"
                                    :data-id="item.id"
                                    data-kind="comment"
                                    @click.stop.prevent="likeBtn(item, index)"
                                >
                                    <i></i>
                                    <span :class="['commentLikeS', 'commentLikeS' + item.id]" style="margin-right: 0">{{item.support_num}}</span>
                                </a>
                            </div>
                            <div :class="['subcmtMask', 'second_level_reply', 'comment_reply_'+item.id, 'clearfix']">
                                <div class="comment_wrap ">
                                    <div class="hd"></div>
                                    <div class="bd clearfix">
                                        <textarea 
                                            :placeholder="'回复@' + item.u_name" 
                                            id="comment_con" 
                                            maxlength="300"
                                            v-model="item.iptVal"
                                            :class="['comment_con', 'replyComment'+item.id, 'faceOut_ipt']"
                                        ></textarea>
                                    </div>
                                    <div class="ft comment_publish clearfix">
                                        <a href="javascript:;" :data-name="item.u_name" id="publishComment" class="normal_comment" :class="{comment_disable: loading}" @click.stop.prevent="sendContent(item, index, 'first')">发送</a>
                                        <i class="cancel-fb" @click.stop.prevent="closeToast(item, index)">取消</i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="second_level_wrap" data-type="second" v-if="item.sub_list.length > 0">
                            <ul class="sub_comment_show">
                                <template v-if="item.sub_list.length <= 3">
                                    <li v-for="(s_item, s_index) in item.sub_list" :key="s_index" class="second_level_comment clearfix">
                                        <div class="second_level_info clearfix">
                                            <p>
                                                <template v-if="s_item.is_direct == 'yes'">
                                                    <span style="color:#2d64ba;font-size: 13px;">{{s_item.u_name}}：</span>
                                                </template>
                                                <template v-else>
                                                    <span style="color:#2d64ba;font-size: 13px;">{{s_item.u_name}}</span>
                                                    <span style="padding: 0; ">回复</span>
                                                    <span style="color:#2d64ba;font-size: 13px;">{{s_item.r_name}}：</span> 
                                                </template>
                                                <span class="comment_reply" v-html="s_item.content"></span>
                                            </p>
                                        </div>
                                    </li>
                                </template>
                                <template v-else>
                                    <template v-for="(s_it) in [0, 1, 2]">
                                        <li :key="s_it.id" class="second_level_comment clearfix" v-if="item.sub_list[s_it]">
                                            <div class="second_level_info clearfix">
                                                <p>
                                                    <template v-if="item.sub_list[s_it] && item.sub_list[s_it].is_direct == 'yes'">
                                                        <span style="color:#2d64ba;font-size: 13px;">{{item.sub_list[s_it] && item.sub_list[s_it].u_name}}：</span>
                                                    </template>
                                                    <template v-else>
                                                        <span style="color:#2d64ba;font-size: 13px;">{{item.sub_list[s_it] && item.sub_list[s_it].u_name}}</span>
                                                        <span style="padding: 0; ">回复</span>
                                                        <span style="color:#2d64ba;font-size: 13px;">{{item.sub_list[s_it] && item.sub_list[s_it].r_name}}：</span> 
                                                    </template>
                                                    <span class="comment_reply" v-html="item.sub_list[s_it] && item.sub_list[s_it].content"></span>
                                                </p>
                                            </div>
                                        </li>
                                    </template>
                                    <div class="all_comment_load clearfix" v-if="item.sub_list.length > 3">
                                        <span class="open_all_comment down" @click.stop.prevent="showList(item)">展开{{item.sub_list.length - 3}}条回复 <i class="icon icon-arw"></i></span>
                                    </div>
                                </template>
                            </ul>
                        </div>
                    </div>
                </li>
                <div style="width: 90%;padding: 0 5%;margin-bottom: 30px;" v-if="commentNum>20"><a href="https://mobile.aigupiao.com/Download/download_open_wx?id=2447405&amp;kind=liveMsgDetail" class="dl_app">打开爱股票APP查看全部{{commentNum}}条评论</a></div>
            </div>
        </div>

        <div class="bottom-banner-container">
            <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui">
                <div class="bottom-banner-content noBonus">
            <span class="content-left">
                <span class="line"></span>
                <span class="title">爱股票</span>
                <span class="line"></span>
                <span class="see-comments">专业投资者社区</span>
                <span class="content-right">
                    <span class="download-btn">打开<img src="https://cdn.aigupiao.com/static/wrap/img/lives_download_bottom_arrow.png" style="transition: opacity 200ms ease; opacity: 1;"></span>
                </span>
            </span>
                </div>
            </a>
        </div>

        <div class="m_bg" v-if="commentListShow" @click.stop.prevent="closeCommentList">
            <div class="m_box" @click.stop.prevent="clickDOM">
                <div class="m_hea">
                    <div class="m_close" @click.stop.prevent="closeCommentList"></div>
                    <div class="m_hea_t">{{commentListIList.length}}条回复</div> 
                </div>

                <ul class="m_ul_f">
                    <li class="first_level_comment" data-type="first">
                        <template v-if="commentInfo.l_id>0 && commentInfo.is_vip_service == 'yes'">
                            <a @click.stop.prevent="l_id_jump(commentInfo.l_id, commentInfo.user_medals_tail)">
                                <img :src="commentInfo.u_avatar">
                            </a>
                        </template>
                        <template v-else>
                            <a :href="user_url(commentInfo)">
                                <img :src="commentInfo.u_avatar">
                            </a>
                        </template>
                        <div class="live_comment_right">
                            <div class="comment_detail clearfix">
                                <p>
                                    <template v-if="commentInfo.l_id>0 && commentInfo.is_vip_service == 'yes'">
                                        <a @click.stop.prevent="l_id_jump(commentInfo.l_id, commentInfo.user_medals_tail)">
                                            <span style="color:#2d64ba;" class="comment_uName">{{commentInfo.u_name}}</span>
                                        </a>
                                    </template>
                                    <template v-else>
                                        <a :href="user_url(commentInfo)">
                                            <span style="color:#2d64ba;" class="comment_uName">{{commentInfo.u_name}}</span>
                                        </a>
                                    </template>
                                </p>
                                <div class="comment_detail_info">
                                    <span style="float: none" class="comment_con comment_con_1" v-html="commentInfo.content"></span>
                                </div>
                                <div class="comment_reply_wrap" style="margin-bottom: 9px;">
                                    <span style="float: left;margin-right: 0;color: #999999;padding: 0;height:16px;line-height: 16px">{{commentInfo.rec_time_desc}}</span>
                                    <span  style="float: left;margin-left: 5px;margin-right: 5px;color: #999999;padding: 0;height:16px;line-height: 16px">·</span>
                                    <a href="javascript:;" class="comment_reply" style="height:16px;line-height: 16px" @click.stop.prevent="replayFn(commentInfo, null, $event, 'info')">回复</a>
                                    <a 
                                        href="javascript:;" 
                                        :class="['comment_point', 'c_likea' + commentInfo.id, {
                                            yizan: commentInfo.is_support == 'yes'
                                        }]"
                                        :data-id="commentInfo.id"
                                        data-kind="comment"
                                        @click.stop.prevent="likeBtn(commentInfo, null, 'info')"
                                    >
                                        <i></i>
                                        <span :class="['commentLikeS', 'commentLikeS' + commentInfo.id]" style="margin-right: 0">{{commentInfo.support_num}}</span>
                                    </a>
                                </div>
                                <div :class="['subcmtMask', 'second_level_reply', 'comment_reply_info'+commentInfo.id, 'clearfix']">
                                    <div class="comment_wrap ">
                                        <div class="hd"></div>
                                        <div class="bd clearfix">
                                            <textarea 
                                                :placeholder="'回复@' + commentInfo.u_name" 
                                                id="comment_con" 
                                                maxlength="300"
                                                v-model="commentInfo.iptVal"
                                                :class="['comment_con', 'replyComment'+commentInfo.id, 'faceOut_ipt']"
                                            ></textarea>
                                        </div>
                                        <div class="ft comment_publish clearfix">
                                            <a href="javascript:;" :data-name="commentInfo.u_name" id="publishComment" class="normal_comment" :class="{comment_disable: loading}" @click.stop.prevent="sendContent(commentInfo, null, 'first_info')">发送</a>
                                            <i class="cancel-fb" @click.stop.prevent="closeToast(commentInfo, null, 'info')">取消</i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>

                <div class="reply-split-content">全部评论</div> 

                <ul class="m_ul">
                    <li class="first_level_comment" data-type="first" v-for="(item, index) in commentListIList" :key="index">
                        <template v-if="item.l_id>0 && item.is_vip_service == 'yes'">
                            <a @click.stop.prevent="l_id_jump(item.l_id, item.user_medals_tail)">
                                <img :src="item.u_avatar">
                            </a>
                        </template>
                        <template v-else>
                            <a :href="user_url(item)">
                                <img :src="item.u_avatar">
                            </a>
                        </template>
                        <div class="live_comment_right">
                            <div class="comment_detail clearfix">
                                <p>
                                    <template v-if="item.l_id>0 && item.is_vip_service == 'yes'">
                                        <a @click.stop.prevent="l_id_jump(item.l_id, item.user_medals_tail)">
                                            <span style="color:#2d64ba;" class="comment_uName">{{item.u_name}}</span>
                                        </a>
                                    </template>
                                    <template v-else>
                                        <a :href="user_url(item)">
                                            <span style="color:#2d64ba;" class="comment_uName">{{item.u_name}}</span>
                                        </a>
                                    </template>
                                </p>
                                <div class="comment_detail_info">
                                    <span style="float: none" class="comment_con comment_con_1" v-html="item.content"></span>
                                </div>
                                <div class="comment_reply_wrap" style="margin-bottom: 9px;">
                                    <span style="float: left;margin-right: 0;color: #999999;padding: 0;height:16px;line-height: 16px">{{item.rec_time_desc}}</span>
                                    <span  style="float: left;margin-left: 5px;margin-right: 5px;color: #999999;padding: 0;height:16px;line-height: 16px">·</span>
                                    <a href="javascript:;" class="comment_reply" style="height:16px;line-height: 16px" @click.stop.prevent="replayFn(item, index, $event, 'list')">回复</a>
                                    <a 
                                        href="javascript:;" 
                                        :class="['comment_point', 'c_likea' + item.id, {
                                            yizan: item.is_support == 'yes'
                                        }]"
                                        :data-id="item.id"
                                        data-kind="comment"
                                        @click.stop.prevent="likeBtn(item, index, 'list')"
                                    >
                                        <i></i>
                                        <span :class="['commentLikeS', 'commentLikeS' + item.id]" style="margin-right: 0">{{item.support_num}}</span>
                                    </a>
                                </div>
                                <div :class="['subcmtMask', 'second_level_reply', 'comment_reply_list'+item.id, 'clearfix']">
                                    <div class="comment_wrap ">
                                        <div class="hd"></div>
                                        <div class="bd clearfix">
                                            <textarea 
                                                :placeholder="'回复@' + item.u_name" 
                                                id="comment_con" 
                                                maxlength="300"
                                                v-model="item.iptVal"
                                                :class="['comment_con', 'replyComment'+item.id, 'faceOut_ipt']"
                                            ></textarea>
                                        </div>
                                        <div class="ft comment_publish clearfix">
                                            <a href="javascript:;" :data-name="item.u_name" id="publishComment" class="normal_comment" :class="{comment_disable: loading}" @click.stop.prevent="sendContent(item, index, 'first_list')">发送</a>
                                            <i class="cancel-fb" @click.stop.prevent="closeToast(item, index, 'list')">取消</i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>


    </div>
    <!-- hsReplicaProfits -->
</template>

<script>
import * as echarts from 'echarts'
import ucenterApi from '@/api/mine/ucenter';
export default {
    name: "hsReplicaProfits",
    data() {
        return {
            env: "",
            cur: "",
            stockInfo: {},
            holdPositionList: [],
            holdPositionListLen: 0,
            yield_tabs: [
                {
                    name: "近1月",
                    type: "month",
                }, {
                    name: "近3月",
                    type: "3month",
                }, {
                    name: "近6月",
                    type: "6month",
                }, {
                    name: "近1年",
                    type: "year",
                }, {
                    name: "成立来",
                    type: "total",
                }
            ],
            yield_check: "6month",
            yidld_info: null,
            colorList: ['#508AE4', '#FA6D6D', '#F7B34A', '#A7ABE9', '#70D1B1', '#749f83'],
            chartList: [],
            chartEmpty: [],
            // WarehouseAdjustmentRecord
            businessList: [], // 调仓记录列表
            commentList: [], // 评论列表
            commentNum: 0, // 评论总数
            userInfo: {},
            pageUserInfo: {}, // 当前页面的用户信息
            isLogin: false,
            loading: false,
            commentListShow: false,
            commentListIList: [],
            commentInfo: {},
            in_zx: "",
            zx_host: "",

            match_id: null, // 大赛ID
            match_info: null, // 大赛信息
        }
    },
    created() {
        this.in_zx = location.host.includes('.aigupiao8.com'); //是否在zx域名下
        var zx_host = location.origin;
        if(!this.in_zx) {
            zx_host = location.origin.replace('.aigupiao.com','.aigupiao8.com');
        }
        this.zx_host = zx_host;
        this.env = this.$env;
        if (location.href.indexOf('dev') > -1 || location.href.indexOf('//192.168.1.202:808') > -1) {
            this.cur = 'dev';
        } else if (location.href.indexOf('beta') > -1) {
            this.cur = 'beta';
        } else {
            this.cur = '';
        }

        this.env = this.cur;
        console.info(this.match_id, this.$route, 'routaer');
        let _query = this.$route.params;

        if(_query.match_id && _query.match_id != '') {
            this.match_id = _query.match_id;
        }
        
        this.getCheckUserInfo(); // 获取当前访问股票的作者信息

        this.profit(this.yield_check); // 收益率走势
        
        this.getHistory(); // 调仓记录

        this.getMatchInfo(); // 获取大赛排名

        this.getUser(); // 获取当前用户的信息

        
    },
    methods: { //// https://apisbeta.aigupiao.com/HsReplicaStocks/profits?source=pc&u_id=44324
        l_id_jump(l_id,user_medals_tail) {
            var is_serve = false;
            $.each(user_medals_tail,function(i,item) {
                if(item.kind === 'serve_vip') {
                    is_serve = true;
                }
            })
            if(is_serve) {
                if(this.in_zx) {
                    window.location.href = '/app_lives/center/id/' + l_id;
                }else {
                    let _this = this;
                    $.ajax({
                        xhrFields: {withCredentials: true},
                        type:'get',
                        url:'/H5ReactZxLogin/zhongXunLogin',
                        data:{ zx_redirect: '/app_lives/center/id/' + l_id},
                        dataType:'json',
                        success:function(res) {
                            if (res.rslt === "succ") {
                                window.location.href = res.data;
                            }else {
                                window.location.href = _this.zx_host+ '/app_lives/center/id/' + l_id;
                            }
                        }

                    })
                }

            }else {
                window.location.href = '/lives/center/id/' + l_id;
            }
        },
        // 切换列表
        checkYield(item) {
            this.yield_check = item;
            this.profit(this.yield_check); // 收益率走势
        },
        //获取个人信息
        async getUser() {
            let data = await ucenterApi.getUserInfo(); 
            let res = {"code":"","status":"success","message":"\u64cd\u4f5c\u6210\u529f","data":{"id":46,"username":"cszh","title":"\u6d4b\u8bd5\u5927\u54e5666","brief":"dev\u73af\u5883\u7684test\u8d26\u53f7\u5927\u54e5","intro":"dev\u73af\u5883\u7684test\u8d26\u53f7\u5927\u54e5","realname":"\u51af\u8c6a\u8c6a","cert_no":"A0690622040001","platform":1,"serve_vip":"yes","is_elite":"no","only_vip_buy":"no","realname_status":"yes","cert_no_status":"yes","image":"http:\/\/img1-cdn-picsh.aigupiao.com\/user\/avatar\/2022-2-22\/16455095335814690=720X696.jpeg","u_id":44324,"avatar":"http:\/\/img1-cdn-picsh.aigupiao.com\/user\/avatar\/2022-2-22\/16455095335814690=720X696.jpeg","nickname":"\u6d4b\u8bd5\u5927\u54e56661","add_v":"0","province":"\u5317\u4eac","city":"\u6d77\u6dc0\u533a","start_year":2,"stock_fund":"","gender":"\u7537","cert_name":"\u51af\u8c6a\u8c6a A0690622040001","is_official":"no","to_ZX":0,"area":"","share":{"share_content":"dev\u73af\u5883\u7684test\u8d26\u53f7\u5927\u54e5(\u5206\u4eab\u81ea@\u7231\u80a1\u7968)","share_logo":"http:\/\/img1-cdn-picsh.aigupiao.com\/user\/avatar\/2022-2-22\/16455095335814690=720X696.jpeg","share_link":"https:\/\/mobiledev.aigupiao8.com\/app_lives\/center\/id\/46","share_open":{"AppID":"wx227b639f584ca603","timestamp":1687845976,"nonceStr":"xnszseCPe38FtFuD","signature":"a2b1a55ee6ea38698ff3efc079fadabd751cdc98","share_link":"https:\/\/mobiledev.aigupiao8.com\/app_lives\/center\/id\/46"},"share_title":"\u6d4b\u8bd5\u5927\u54e5666\u7684\u4e2a\u4eba\u4e3b\u9875-\u7231\u80a1\u7968"},"tag_list":[{"label":"\u4ef7\u503c\u6295\u8d44"},{"label":"\u77ed\u7ebf\u8fbe\u4eba"}],"mobile_env":"dev"}};
            if(this.cur == 'dev') {
                this.userInfo = res.data;  
            } else {
                this.userInfo = data;  
            }
            if(!this.userInfo) {
                this.isLogin = false;
            } else {
                this.isLogin = true;
            }

            this.getHsReplicaStocksFn(); // 获取改用的炒股信息

            this.getHoldPositionFn(); // 持仓记录

            // this.position_detail(); // 获取饼状图数据

            this.getCommentListFn(); // 获取评论列表
            
        },
        // 跳转下载页
        jumpDownloadPage() {
            location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui";
        },
        // 展示列表
        showList(item) {
            console.info("all_comment_load")
            var _this = this;
            var herf=location.href.split('.')[0];
            var url=''; //区分测试和正式服务器接口
            if (herf.indexOf('dev')!=-1) {
                url="https://apisdev.aigupiao.com";
            }else if (herf.indexOf('test')!=-1) {
                url="https://apistest.aigupiao.com";
            }else if (herf.indexOf('beta')!=-1) {
                url="https://apisbeta.aigupiao.com";
            }else{
                url="https://apis.aigupiao.com"
            }
            $.ajax({
                xhrFields:{
                withCredentials:true,
                },
                url:`${url}/Comment/replyCommentList`,
                dataType:'json',
                data:{
                    source: 'pc',
                    id: item.id,
                    before: '',
                    u_id: _this.userInfo.id,
                }, 
                success:function (res) {
                    console.log(res)
                    if(res.rslt == "succ"){
                        console.log(res.rslt)
                        _this.commentListShow = true;
                        _this.$nextTick(()=>{
                            $('body').css('overflow','hidden');
                            $('.m_box').slideDown(); 
                            if(localStorage.getItem("praised_status_exp_comment_"+res.list.id) == 'yes') {
                                res.list.is_support = 'yes'
                            } else {
                                res.list.is_support = 'no'
                            }
                            res.reply_list.forEach((i, v)=>{
                                if(localStorage.getItem("praised_status_exp_comment_"+i.id) == 'yes') {
                                    i.is_support = 'yes';
                                } else {
                                    i.is_support = 'no';
                                }
                            })
                            _this.commentInfo = res.list;
                            _this.commentListIList = res.reply_list
                        })
                    }
                }
            })
        },
        closeCommentList() {
            $('.m_box').slideUp(); 
            $('body').css('overflow','auto');
            setTimeout(() => {
                this.commentListShow = false;
            }, 100);
        },
        clickDOM() {
            console.info('click here')
        },
        rList(list) {
            list = list.splice(0, 3)
            console.info(list)
            return list
        },
        // 时间戳转换
        timestampToTime(timestamp) {
            let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let y = date.getFullYear();
            let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
            let D = date.getDate();
            let h = date.getHours();
            let m = date.getMinutes();
            let s = date.getSeconds();
            if(D<10) {
                D = '0' + D;
            }
            if(h < 10) {
                h = '0' + h;
            }
            if(m < 10) {
                m = '0' + m;
            }
            if(s < 10) {
                s = '0' + s;
            }
            return `${y}/${M}/${D} ${h}:${m}:${s}`;
        },
        // 获取当前这个用户的信息
        getCheckUserInfo() {
            let _that = this;

            let params = {
                source: 'pc',
                u_id: this.u_id
            }
            if(this.match_id) {
                params.match_id = this.match_id;
            }
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                url: `https://apis${this.env}.aigupiao.com/HsReplicaStocks/stock_info`,
                data: params,
                dataType: 'json',
                beforeSend: function (XMLHttpRequest) { },
                error: function () { return false; },
                success: function (res) {
                    console.info(res, 'res');
                    if (res.rslt == 'succ') {
                        let result = res.data;
                        _that.pageUserInfo = result;
                        console.info(result,' result___')
                    }
                }
            });
        },
        getHsReplicaStocksFn() {
            let _that = this;
            let params = {
                source: 'pc',
                u_id: this.u_id,
                user_id: this.userInfo.u_id,
                c_u_id: this.userInfo.u_id,
            }
            if(this.match_id) {
                params.match_id = this.match_id;
                params.appversion = '10.8.0'
            }
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                url: `https://apis${this.env}.aigupiao.com/HsReplicaStocks/profits`,
                data: params,
                dataType: 'json',
                beforeSend: function (XMLHttpRequest) { },
                error: function () { return false; },
                success: function (res) {
                    console.info(res, 'res');
                    if (res.rslt == 'succ') {
                        let result = res.data;
                        _that.stockInfo = result;

                        let share_data = {
                            share_link: location.href,
                            image: "https://cdncos.aigupiao.com/assets/wap/img/logo80x80.png?time=1703043151522",
                            content: "（分享自 @爱股票APP）"
                        };
                        // 自己的
                        if(_that.userInfo && _that.userInfo.id == result.g_id) {
                            // 模拟组合
                            if(!_that.match_id) {
                                share_data.title = `欢迎关注我的投资组合，总收益${result.profit_rate_t || "-"}%，超过${result.profit_rank || "0.00"}%的组合！`
                            }
                            // 模拟大赛
                            else {
                                share_data.title = `我的模拟大赛组合，总收益为${result.profit_rate_t || "-"}%，推荐关注！`
                            }
                        } 
                        // 分享的别人的
                        else {
                            // 模拟组合
                            if(!_that.match_id) {
                                share_data.title = `我发现了这个组合，总收益${result.profit_rate_t || "-"}%，超过${result.profit_rank || "0.00"}%的组合，推荐关注！`
                            }
                            // 模拟大赛
                            else {
                                share_data.title = `我发现了这个大赛组合，总收益${result.profit_rate_t || "-"}%，推荐关注！`
                            }
                        }

                        _that.getshare(share_data)
                    }
                }
                // userInfo
            });
        },
        // 获取当前持仓记录
        getHoldPositionFn() {
            let _that = this, _this = this;
            
            let params = {
                source: 'pc',
                u_id: this.u_id,
                c_u_id: this.userInfo.id,
            }
            if(this.match_id) {
                params.match_id = this.match_id;
            }
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                url: `https://apis${this.env}.aigupiao.com/HsReplicaStocks/positions`,
                dataType: 'json',
                data: params,
                beforeSend: function (XMLHttpRequest) { },
                error: function () { return false; },
                success: function (res) {
                    console.info(res, 'res');
                    if (res.rslt == 'succ') {
                        let result = res.data;
                        // var o_data = _data.data.stock_count;
                        var o_list = result.list;

                        console.info(o_list,'o_list')
                        let n_o_list = [], _cunt = 0;
                        for(let i=0,ilen=o_list.length;i<ilen;i++) {
                            if(i<5) {
                                n_o_list.push(o_list[i]);
                            } else {
                                _cunt += (o_list[i].stock_position.split('%')[0] * 1)
                            }
                        }
                        _cunt = _cunt.toFixed(2);

                        if(_cunt > 0) {
                            n_o_list.push({
                                stock_name: "其他",
                                stock_position: _cunt + "%"
                            })
                        }

                        if(result.amount_position != 0 && result.amount_position.split('%')[0] != 0) {
                            _this.chartEmpty.push({
                                stock_name: "现金",
                                stock_position: result.amount_position
                            })
                        }
                        
                        _this.chartList = n_o_list;
                        var cash_position = result.amount_position;
                        $('.chart_body_right').html("");
                        $('.chart_info').html("");
                        let c_data = [], c_data2 = [];
                        if (n_o_list.length > 5) {
                            $('.see_more_btn').show();
                        }
                        for (var i = 0; i < n_o_list.length; i++) {
                            c_data.unshift(n_o_list[i].stock_position);
                            c_data2.unshift(n_o_list[i].stock_name);
                        }
                        _this.colorList =_this.colorList.splice(0, n_o_list.length)
                        _this.c_chatr(c_data, c_data2,  cash_position);

                        
                        _that.holdPositionListLen = result.list.length;
                        _that.holdPositionList = result.list.splice(0, 5);
                    }
                }
            });
        },
        // 获取评论列表
        getCommentListFn() {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                url: `https://app${this.env}.aigupiao.com/api2/comment.php`,
                data: {
                    act: "list",
                    u_id: _this.userInfo.id,
                    id: _this.u_id,
                    kind: "stock_group",
                    // md: "",
                    before: 0,
                    number: 20,
                    source: 'pc',
                    web_data: 'yes',
                    division: 1,
                    order: 'desc',
                },
                dataType: 'json',
                beforeSend: function (XMLHttpRequest) { },
                error: function () { return false; },
                success: function (res) {
                    console.info(res, 'res');
                    if (res.rslt == 'succ') {
                        let result = res.comment_list;
                        result.forEach((i, v)=>{
                            if(localStorage.getItem("praised_status_exp_comment_"+i.id) == 'yes') {
                                i.is_support = 'yes';
                            } else {
                                i.is_support = 'no';
                            }
                        })
                        _this.commentList = result;
                        _this.commentNum = res.comment_num;
                        // commentList
                    }
                }
            });
        },
        user_url(comment) {
            var _url = "";
            if(comment.l_id>0){
                if(comment.is_vip_service === 'yes'){
                    _url = 'javascript:;tozxPerson2('+comment.l_id+','+JSON.stringify(comment.user_medals_tail)+')';

                }else {
                    _url = '/lives/center/id/'+comment.l_id+'.html';

                }
            }else{
                _url ='/ucenter/user_home/m_u_id/'+comment.u_id+'.html'
            }

            return _url;
        },
        profit(_type) { // total
            var p_id = "";
            var o_url = location.href;
            if (o_url.indexOf('?m_u_id') != -1) {
                var o_location = o_url.split("?");
                var url_id = o_location[1].split("=");
                p_id = url_id[1];
            } else if(this.match_id) {
                p_id = this.u_id;
            } else {
                return
            }
            var _day_num = 30;
            switch (_type) {
                case "month":
                    _day_num = 30;
                    break;
                case "3month":
                    _day_num = 90;
                    break;
                case "6month":
                    _day_num = 180;
                    break;
                case "year":
                    _day_num = 365;
                    break;
                case "total":
                    _day_num = 0;
                    break;
            }

            let _this = this;

            let params = {
                source: 'pc',
                user_id: p_id,
                day_num: _day_num,
            }
            if(this.match_id) {
                params.match_id = this.match_id;
            }
            $.ajax({
                xhrFields: { withCredentials: true },
                crossDomain: true,
                url: `https://app${this.env}.aigupiao.com/v1/user/userProfitList`,
                data: params,
                type: "get",
                success: function success(data) {
                    if (data.status == 'success') {
                        var _data = data.data;
                        var hs300 = JSON.parse(JSON.stringify(_data.sh300_profit_list)),
                            z_data = JSON.parse(JSON.stringify(_data.user_profit_list)); // 只去时间
                        var _bt_data = [],
                            _hs_data = [];

                        _this.yidld_info = _data;
                        var date = [];
                        var _h_data = "",
                            _b_data = "";
                        for (var item in hs300) {
                            if (!z_data[item]) {
                                _bt_data.push(_b_data);
                            } else {
                                _b_data = z_data[item].asset_balance;
                                _bt_data.push(z_data[item].asset_balance);
                            }

                            if (!hs300[item]) {
                                _hs_data.push(_h_data);
                            } else {
                                _h_data = hs300[item].close;
                                _hs_data.push(hs300[item].close);
                                date.push(hs300[item].date_ymd);
                            }
                        }

                        // 遍历两个数组然后计算出涨跌幅
                        var _bt_first_value = 0,
                            _hs_first_value = 0;
                        for (var _item in _bt_data) {
                            if (_bt_data[_item] && _bt_data[_item]) {
                                _bt_first_value = _bt_data[_item];
                                break;
                            }
                        }

                        for (var _item2 in _hs_data) {
                            if (_hs_data[_item2] && _hs_data[_item2]) {
                                _hs_first_value = _hs_data[_item2];
                                break;
                            }
                        }

                        for (var _item3 in _bt_data) {
                            if (_bt_data[_item3]) {
                                _bt_data[_item3] = ((_bt_data[_item3] - _bt_first_value) / _bt_first_value * 100).toFixed(2);
                            }
                        }
                        for (var _item4 in _hs_data) {
                            if (_hs_data[_item4]) {
                                _hs_data[_item4] = ((_hs_data[_item4] - _hs_first_value) / _hs_first_value * 100).toFixed(2);
                            }
                        }

                        _this.z_line_new(date, _bt_data, _hs_data);
                    } else {
                        // error
                    }
                }
            });
        },
        z_line_new(_longTime, z_data, hs300) {
            var myChart = echarts.init(document.getElementById('main_z'));
            myChart.clear();
            var _max = Math.max.apply(null, z_data.concat(hs300));
            var _min = Math.min.apply(null, z_data.concat(hs300));
            var user_legend = "本模拟炒股";
            var option2 = {
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: '#fff',
                    borderColor: '#BDBDBD',
                    borderWidth: '1',
                    textStyle: {
                        fontSize: 12,
                        color: '#333333'
                    },
                    position: function position(pos, params, el, elRect, size) {
                        var obj = { top: 30 };
                        if (+(pos[0] < size.viewSize[0] / 2)) {
                            obj['right'] = 30;
                        } else {
                            obj['left'] = 30;
                        }
                        return obj;
                    },

                    formatter: function formatter(params, ticket, callback) {
                        var date_url = params[0].name; //日期标识
                        var user_value = params[0] && params[0].value && params[0].value + '%' || '--';
                        var hs_value = params[1] && params[1].value && params[1].value + '%' || '--';
                        function toHTML() {
                            var res = '<div>';
                            res += '<div class="clearfix" style="margin: 8px 0 ;"><p style="float: left">时间 : </p><p style="float: right">' + date_url + '</p></div>';
                            res += '<div class="clearfix" style="margin: 8px 0 ;">' + '<p style="float: left;margin-left: 3px;">' + '<span style="display: inline-block;width: 10px;height: 10px;border-radius: 50%;background: #CC0055;vertical-align:baseline;margin-right: 8px;"></span>' + '组合:</p>' + '<p style="float: right;  ">' + user_value + '</p>' + '</div>';
                            res += '<div class="clearfix">' + '<p style="float: left;margin-left: 3px;">' + '<span style="display: inline-block;width: 10px;height: 10px;border-radius: 50%;background: #0066CC;vertical-align: baseline;margin-right: 8px;"></span>' + '沪深: </p>' + '<p style="float: right;">' + hs_value + '</p>' + '</div>';
                            res += '</div>';

                            return res;
                        }

                        return toHTML();
                    },
                    extraCssText: 'min-width:114px;padding:0 16px 11px 14px'

                },
                legend: {
                    data: [user_legend, '沪深300'],
                    // bottom:70,
                    top: 10,
                    left: 30,
                    icon: 'circle',
                    textStyle: {
                        color: '#939393',
                        fontSize: 13
                    },
                    itemGap: 50,
                    itemWidth: 10,
                    itemHeight: 10,
                    selectedMode: false
                },
                grid: {
                    left: '0%',
                    right: '10%',
                    bottom: '3%',
                    top: '14%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category', // time
                    boundaryGap: true,
                    data: _longTime,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#C4CDE0'
                        },
                        onZero: false
                    },

                    axisLabel: {
                        margin: 15,
                        color: '#939393',
                        fontSize: 14,
                        padding: [10, 20, 17, 20],
                        formatter: function formatter(value, index) {
                            return value;
                        },
                        showMaxLabel: true,
                        interval: _longTime.length - 2
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            type: 'dashed'
                        }

                    }
                }],
                yAxis: [{
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}%',
                        inside: false,
                        margin: 0,
                        color: '#939393',
                        fontSize: 12,
                        padding: [0, 0, 0, 15]
                    },
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#EBF1FD'
                        }
                    },
                    // position: 'right',
                    max: _max,
                    min: _min,
                    // interval: _main / 2
                }],
                series: [{
                    name: user_legend,
                    type: 'line',
                    data: z_data,
                    color: '#CC0055',
                    showSymbol: false,
                    connectNulls: true
                }, {
                    name: '沪深300',
                    type: 'line',
                    data: hs300,
                    color: '#0066CC',
                    showSymbol: false,
                    connectNulls: true
                }]
            };
            myChart.setOption(option2);
        },
        // 获取饼状图数据
        position_detail() {
            let _this = this;
            var p_id2 = "";
            var o_url2 = location.href;
            if (o_url2.indexOf('?m_u_id') != -1) {
                var o_location2 = o_url2.split("?");
                var url_id2 = o_location2[1].split("=");
                p_id2 = url_id2[1];
            }
            else if(this.match_id) {
                p_id2 = this.u_id;
            }
            else {
                p_id2 = this.userInfo.id;
            }


            let params = {
                act: 'stock_pisition',
                u_id: p_id2,
                c_u_id: this.userInfo.id,
            }
            if(this.match_id) {
                params.match_id = this.match_id;
            }
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                dataType: 'json',
                url: `https://apis${this.env}.aigupiao.com/HsReplicaStocks/positions`,
                data: params,
                success: function (_data) {
                    if (_data.rslt == "succ") {
                        
                    }
                }
            });
        },
        // 绘制饼状图
        c_chatr(_data, _data2, o_cash) {
            // 基于准备好的dom，初始化echarts实例
            var _d = [];
            var d_color = JSON.parse(JSON.stringify(this.colorList));
            d_color = d_color.reverse()

            // this.colorList = this.colorList.reverse()
            if (_data.length == 0) {
                _d[0] = { value: 0, name: '空仓' };
            }
            else {
                for (var i = 0; i < _data.length; i++) {
                    var o_value = Number(_data[i].replace("%", ""));
                    var o_value2 = o_value.toFixed(2);
                    _d[i] = {
                        value: o_value2, name: _data2[i], itemStyle: {
                            normal: {
                                color: d_color[i],
                            }
                        }
                    };
                }
                var n_cash = Number(o_cash.replace("%", ""));
                var t_position = 100 - n_cash;
                var t_position2 = t_position.toFixed(2);
                var _last = _data.length;
                _d[_last] = {
                    value: n_cash, name: '现金', itemStyle: {
                        normal: {
                            color: '#ddd',
                        }
                    }
                };
                d_color[_last] = '#f0f0f0';
            }
            if (!t_position2 || t_position2 == 'undefined') {
                t_position2 = '0';
            }
            var chart_detail = $('<span>当前仓位</span>' +
                '<p>' + t_position2 + '%</p>');
            $('.chart_info').append(chart_detail);
            var myChart = echarts.init(document.getElementById('main_c'));
            // 指定图表的配置项和数据
            var option1 = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {d}%"
                },
                series: [
                    {
                        name: '当前仓位',
                        type: 'pie',
                        radius: ['55%', '86%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: false,
                                textStyle: {
                                    fontSize: '12',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        //	            color:d_color,
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: _d
                    }
                ]
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option1);
        },
        // 获取调仓记录
        getHistory() {
            let _that = this;
            let params = {
                act: 'stock_pisition',
                u_id: this.u_id,
            }
            if(this.match_id) {
                params.match_id = this.match_id;
            }
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                url: `https://apis${this.env}.aigupiao.com/HsReplicaStocks/business`,
                data: params,
                dataType: 'json',
                beforeSend: function (XMLHttpRequest) { },
                error: function () { return false; },
                success: function (res) {
                    console.info(res, 'res');
                    if (res.rslt == 'succ') {
                        let result = res.data;
                        let emptyArr = [];
                        if(result && result.length > 0) {
                            let _firstDate = result[0].sort_time;
                            let _td=  new Date(_firstDate * 1000)
                            _td.setHours(0)
                            _td.setMinutes(0)
                            _td.setSeconds(0)
                            for(let i=0,ilen=result.length;i<ilen;i++) {
                                if(result[i].sort_time * 1000 > _td) {
                                    emptyArr.push(result[i])
                                }
                            }
                        }
                        _that.businessList = emptyArr;//.splice(0, 3);
                    }
                }
            });
        },
        // 点赞按钮
        likeBtn(item, index, type) {
            var _id = item.id;
            if(item.is_support == 'yes' || localStorage.getItem("praised_status_exp_comment_"+_id) == 'yes') {
                return
            }

            let _this = this;
            jQuery.post(
                // `https://www${this.cur}.aigupiao.com/Api/Attitude/publish`,
                "/praised/add",
                {kind:"comment", id:_id, type: 'support'},
                function(data){
                    if(type == 'info') {
                        _this.$set(_this.commentInfo, 'is_support', 'yes');
                        _this.$set(_this.commentInfo, 'support_num', _this.commentInfo.support_num = _this.commentInfo.support_num * 1+ 1);
                    } else if(type == 'list') {
                        _this.$set(_this.commentListIList[index], 'is_support', 'yes');
                        _this.$set(_this.commentListIList[index], 'support_num', _this.commentListIList[index].support_num = _this.commentListIList[index].support_num * 1+ 1);
                    } else {
                        _this.$set(_this.commentList[index], 'is_support', 'yes');
                        _this.$set(_this.commentList[index], 'support_num', _this.commentList[index].support_num = _this.commentList[index].support_num * 1+ 1);
                    }

                    localStorage.setItem("praised_status_exp_comment_"+_id,"yes");
                }
            );
        },
        // 是否在微信
        isWeiXin(){
            var ua = window.navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                return true;
            }else{
                return false;
            }
        },
        // 是否需要登录
        loginFn() {
            this.$confirm({
                title: "您还没有登录，是否登录？",
                yesBtnText: "确定",
            }).then(() => {
                window.location.href = "/login/index/rd/" + new Date() * 1 + ".html";
            })
            .catch(() => {});
        },
        // 点击回复按钮
        replayFn(item, index, e, type) {
            if(!this.userInfo) {
                this.loginFn();
            } else {
                // isLogin
                let iptDom = $('.comment_reply_' + item.id);
                if(type == 'info') {
                    iptDom = $('.comment_reply_info' + item.id);
                } else if(type == 'list') {
                    iptDom = $('.comment_reply_list' + item.id);
                }
                if(iptDom.length>0) {
                    //二级评论点击回复展开收起
                    if(iptDom.is(":hidden")){
                        $('.second_level_reply').hide();
                        iptDom.slideDown();
                        if(type == 'info') {
                            this.$set(this.commentInfo, 'iptVal', '')
                        } else if(type == 'list') {
                            this.$set(this.commentListIList[index], 'iptVal', '')
                        } else {
                            this.$set(this.commentList[index], 'iptVal', '')
                        }
                        // iptDom.find('textarea').val(''); //展开部分评论清空
                        iptDom.find('textarea').focus();
                    }
                    else{
                        iptDom.slideUp();
                    }
                }
            }
        },
        closeToast(item, index, type) {
            let iptDom = $('.comment_reply_' + item.id);
            if(type == 'info') {
                iptDom = $('.comment_reply_info' + item.id);
            } else if(type == 'list') {
                iptDom = $('.comment_reply_list' + item.id);
            }
            if(iptDom.length>0) {
                iptDom.slideUp();
            }
        },
        // 发送消息接口
        sendContent(item, index, ckind) {
            if(!this.loading) {
                this.loading = true;
                var _this = this;
                let query = {
                    kind: item.kind,
                    id: this.u_id,//内容id
                    u_id: this.userInfo.id,
                    image: "",
                    content: item.iptVal,
                    sync_live_msg: 'no',//老师同步
                    sync_user_msg: 'no',//用户同步
                };
                if(ckind != 'content'){
                    //f_id评论id
                    query.f_id = item.id;
                }

                // query.md = window.md;
                query.act = "publish";
                query.source = "pc";
                query.pc_new_comment = 1;

                $.ajax({
                    type: 'post',
                    url: `https://app${this.env}.aigupiao.com/api/comment.php`,
                    dataType: 'json',
                    data: query,
                    beforeSend: function (XMLHttpRequest) {},
                    error: function () {},
                    success: function (data) {
                        if (data.rslt == "succ") {
                            if(ckind == 'first') {
                                _this.commentList[index].sub_list.unshift({
                                    "id": data.commen_id,
                                    "u_name": data.share_msg.nickname,
                                    "content": data.share_msg.content,
                                    "is_direct": "yes",
                                },)
                                _this.$set(_this.commentList[index], 'iptVal', '')
                            } else {
                                // 
                                _this.commentListIList.unshift({
                                    "id": data.commen_id,
                                    "u_name": data.share_msg.nickname,
                                    "content": data.share_msg.content,
                                    "is_direct": "yes",
                                    "rec_time_desc": data.share_msg.rec_time_desc,
                                    "u_avatar": data.share_msg.avatar
                                },)
                            }
                        }
                        _this.loading = false;
                        _this.pl_pop(data.info)
                        // isLogin
                        let iptDom = $('.comment_reply_' + item.id);
                        
                        if(ckind == 'first_info') {
                            iptDom = $('.comment_reply_info' + item.id);
                        } else if(ckind == 'first_list') {
                            iptDom = $('.comment_reply_list' + item.id);
                        }
                        iptDom && iptDom.slideUp();
                    }
                });
            }
        },
        pl_pop(info){
            var pop_html ='<div class="pop_html" style="position:fixed;z-index:10000;top:20%;left:50%;margin-left: -120px;width:200px;padding: 20px 20px;box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);border-radius: 2px;background-color: #999; ">'+
                '<i class="pop_html_close" style="position:absolute;top:5px;right:5px;width:12px;height:12px;cursor:pointer;background: url(https://cdn.aigupiao.com/static/pc/img/nav/close_white.png) no-repeat"></i>'+
                '<p style="font-size:13px;line-height: 25px;color: #fff;text-align: center">'+info+'</p>'+
                '</div>';
            $('body').append(pop_html);
            $('body').find('.pop_html').fadeOut(3000);
            $('body').on('click','.pop_html_close',function(){
                $('.pop_html').hide()
            });
        },
        // 获取大赛排名接口
        getMatchInfo() {
            if(!this.match_id) {
                return
            }
            let _this = this;
            $.ajax({ xhrFields: {withCredentials: true},
                type: 'get',
                url: `https://apis${this.env}.aigupiao.com/goapi/match/details`,
                data: {
                    source: "pc",
                    appversion: "10.6.2",
                    u_id: this.u_id
                },
                dataType: 'json',
                beforeSend: function (XMLHttpRequest){},
                success: function(data){
                    if(data.code == 1) {
                        let result = data.data;
                        _this.match_info = result;
                        console.info(_this.match_info,'match_info')
                    }
                }
            });
        },
        // 分享
        async getshare(share_data1) {
            let url = location.href;
            let data = await ucenterApi.getShare({
                url
            });
            let share_data = {
                share_content :share_data1.content,
                share_link :share_data1.share_link,
                share_logo:share_data1.image,
                share_title:share_data1.title,
                share_title_qq:share_data1.title,
                share_title_wx:share_data1.title,
                share_open:{
                    AppID:data.AppID,
                    nonceStr:data.nonceStr,
                    signature:data.signature,
                    timestamp:data.timestamp,
                    share_link :share_data1.share_link,
                }
            }
            console.log(share_data)
            this.$share(share_data);
        },
    },
    computed: {
        u_id() {
            if(this.match_id) {
                return this.$route.params.m_u_id
            }
            else {
                return this.$route.query.m_u_id
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

@function imgmask($c) {
    @return 0 rem2(5px) rem2(22px) rem2(2px) $c;
}

.stock_wrap {
    position: fixed;
    overflow-x: hidden;
    overflow-y: auto;
    top: 0;
    width: 100%;
    bottom: 0;
    background-color: #F4F5F6;

    .header_wrap {
        width: 100%;
        height: 163px;
        padding: 21px 10px 11px 15px;
        box-sizing: border-box;
        background: linear-gradient(226deg, #198AB3 0%, #48BDD6 100%);

        .investment_name {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 13px;

            h4 {
                font-size: 16px;
                line-height: 22.5px;
                color: #fff;
                font-weight: normal;
            }

            button {
                width: 59.5px;
                height: 25px;
                text-align: left;
                padding-left: 24px;
                padding-right: 0;
                white-space: nowrap;
                font-size: 12px;
                color: #fff;
                background-image: url("https://cdncos.aigupiao.com/assets/wap/img/vue_mobile/add.png");
                background-size: 9px;
                background-position: 9.5px center;
                background-color: rgba(255, 255, 255, 0.24);
                ;
                background-repeat: no-repeat;
                border-radius: 2px;
                border: 0.5px solid #fff;
                outline: none;
            }
        }

        .profit_wrap {
            display: flex;
            flex-direction: row;
            margin-bottom: 17px;

            .all_profit {
                padding-right: 30.5px;
                flex: 3;

                span {
                    font-size: 28px;
                    line-height: 39px;
                    color: #fff;
                    font-weight: bold;
                    text-align: center;
                }
            }

            .day_profit {
                padding: 0 23.5px 0 20.5px;
            }

            .month_profit {
                padding-left: 20.5px;
            }

            div {
                display: inline-flex;
                flex-direction: column;
                justify-content: flex-end;

                p {
                    font-size: 14px;
                    line-height: 18px;
                    color: rgba(255, 255, 255, 0.71);
                    text-align: center;
                }

                &.left_line {
                    position: relative;
                    flex: 1;

                    span {
                        font-size: 15px;
                        line-height: 21px;
                        color: #fff;
                        text-align: center;
                    }

                    &::before {
                        content: "";
                        width: 0.5px;
                        height: 35.1px;
                        background-color: rgba(255, 255, 255, .3);
                        position: absolute;
                        left: 0;
                        bottom: 3px;
                    }
                }
            }
        }

        .profit_box {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .profit_left,
            .profit_right {
                font-size: 13px;
                line-height: 18px;
                color: #D9EFF5;

                .profit_left_p3 {
                    span {
                        color: #FFFCBD;
                    }
                }
            }
        }
    }

    // 主理人信息
    .pri_person_info {
        width: 100%;
        height: 66px;
        background-color: #FFFFFF;
        padding: 0 15px 0 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        box-sizing: border-box;
        margin-bottom: 6px;

        .person_avatar {
            width: 42px;
            height: 42px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 6px;

            img {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
            }
        }

        .person_info {
            text-align: left;
            flex: 1;
            overflow: hidden;

            .person_info_name {
                font-size: 14px;
                line-height: 17px;
                color: #333;
                font-weight: bold;
                margin-bottom: 6px;
            }

            .person_info_brief {
                font-size: 13px;
                line-height: 15px;
                color: #9D9D9D;
                font-weight: normal;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    // 持仓信息
    .hold_position {
        width: 100%;
        height: auto;
        background-color: #fff;
        margin-bottom: 6px;

        .hold_position_title {
            width: 100%;
            height: 43px;
            line-height: 43px;
            padding-left: 12px;
            font-size: 15px;
            color: #333;
            box-sizing: border-box;
            border-bottom: 0.5px solid #EBEBEB;
        }

        .hold_position_header {
            width: 100%;
            height: 43px;
            line-height: 43px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            div {
                font-size: 13px;
                color: #333;
                flex: 3;

                &:first-child {
                    padding-left: 12px;
                    flex: 4;
                }

                &:last-child {
                    padding-right: 14px;
                    text-align: right;
                    flex: 2;
                }
            }
        }

        .hold_position_footer {
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: rgba(172, 172, 172);
            border-top: 0.5px solid #EbEbEb;
        }

        ul {
            width: 100%;
            height: auto;

            li {
                width: 100%;
                height: 51px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                border-top: 0.5px solid #EbEbEb;

                div {
                    flex: 3;

                    &.stock_info {
                        padding-left: 12px;
                        text-align: left;
                        flex: 4;

                        .stock_name {
                            font-size: 14px;
                            line-height: 17px;
                            color: #333;
                            font-weight: bold;
                            margin-bottom: 2px;
                        }

                        .stock_code {
                            font-size: 12px;
                            line-height: 16.5px;
                            color: #9F9F9F;
                            font-weight: normal;
                        }
                    }

                    &.stock_val {
                        padding-left: 1.5px;

                        .stock_last {
                            font-size: 14px;
                            line-height: 17px;
                            color: #333;
                            font-weight: bold;
                        }

                        .stock_cost {
                            font-size: 12px;
                            line-height: 16.5px;
                            color: #9F9F9F;
                            font-weight: bold;
                        }
                    }

                    &.stock_loss {
                        flex: 2;
                        padding-right: 10px;
                        text-align: right;

                        &.bind_red {

                            .sotck_chg,
                            .stock_chg_pct {
                                color: #FF4A43;
                            }
                        }

                        &.bind_green {

                            .sotck_chg,
                            .stock_chg_pct {
                                color: #00C98F;
                            }
                        }

                        .sotck_chg {
                            font-size: 14px;
                            line-height: 20px;
                            color: #333;
                            font-weight: bold;
                            margin-bottom: 0.5px;
                        }

                        .stock_chg_pct {
                            font-size: 12px;
                            line-height: 16.5px;
                        }
                    }
                }
            }
        }
    }

    .all_comment_load  {

        &> span {
            -webkit-text-size-adjust: none;
            word-break: break-word;
            list-style: none;
            padding: 0;
            margin: 0;
            color: #4977B4;
            font-size: 13px;
            height: 19px;
            display: flex;
            align-items: center;
    
            i {
                -webkit-text-size-adjust: none;
                word-break: break-word;
                list-style: none;
                color: #4977B4;
                font-size: 13px;
                padding: 0;
                margin: 0;
                display: inline-block;
                width: 4.5px;
                height: 8px;
                margin-left: 4px;
                background: url("https://cdncos.aigupiao.com/assets/wap/img/right.png") no-repeat;
                background-size: cover;
            }
        }
    }

    // 收益率走势
    .yield_trend {
        width: 100%;
        height: auto;
        background-color: #fff;
        padding-bottom: 12.5px;
        box-sizing: border-box;
        margin-bottom: 6px;

        .yield_trend_head {
            width: 100%;
            height: 42.5px;
            border-bottom: 0.5px solid #EBEBEB;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 12px;

            .yield_trend_head_left {

                .yield_trend_head_left_title {
                    font-size: 15px;
                    line-height: 18px;
                    color: #333333;
                    margin-right: 6px;
                }

                .yield_trend_head_left_time {
                    font-size: 13px;
                    line-height: 18px;
                    color: #939393;
                }
            }

            .yield_trend_head_right {

                button {
                    font-size: 14px;
                    line-height: 18px;
                    color: #636363;
                    background-color: transparent;
                    background-image: url("https://cdncos.aigupiao.com/assets/wap/img/hsReplicaProfits/right_arrow.png");
                    background-repeat: no-repeat;
                    background-position: right center;
                    background-size: 9px 13.5px;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    padding: 0 14px 0 0;
                }
            }
        }

        .yield_trend_info {
            margin: 0 10px;
            height: 48px;
            background-color: #F4F6F8;
            border-radius: 5px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 34px;
            box-sizing: border-box;
            margin-top: 15px;

            span {
                font-size: 13px;
                line-height: 18.5px;
                color: #636363;

                em {
                    font-style: normal;
                    font-size: 14px;
                    margin-left: 12px;

                    &.bind_red {
                        color: #FE484A
                    }

                    &.bind_green {
                        color: #00CA8F;
                    }
                }
            }
        }

        .yield_trend_tabs {
            margin: 16px 10px 0;
            height: auto;
            display: flex;
            flex-direction: row;
            border: 0.5px solid #D8D8D8;
            border-radius: 2px;

            button {
                flex: 1;
                background-color: transparent;
                font-size: 13px;
                color: #636363;
                height: 31px;
                border: none;
                outline: none;
                border-right: 0.5px solid #E9E9E9;

                &:last-child {
                    border: none;
                }

                &.bind_this {
                    color: #333;
                    background-color: #F6F6F6;
                }
            }
        }
    }

    // 仓位图
    .chart_header {
        width: 100%;
        height: 42.5px;
        border-bottom: 0.5px solid #EBEBEB;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 12px;
        background-color: #fff;

        .chart_header_left {

            .chart_header_left_title {
                font-size: 15px;
                line-height: 18px;
                color: #333333;
                margin-right: 6px;
            }
        }

        .chart_header_right {

            button {
                font-size: 14px;
                line-height: 18px;
                color: #636363;
                background-color: transparent;
                background-image: url("https://cdncos.aigupiao.com/assets/wap/img/hsReplicaProfits/right_arrow.png");
                background-repeat: no-repeat;
                background-position: right center;
                background-size: 9px 13.5px;
                border: none;
                outline: none;
                cursor: pointer;
                padding: 0 14px 0 0;
            }
        }
    }

    // 仓位图
    #canvas-holder {
        display: flex;
        background-color: #fff;
        padding-top: 20px;

        .canvas-holder-left {
            position: relative;
            height: 180px;

            .chart_info {
                text-align: center;
                width: 88px;
                position: absolute;
                -webkit-transform: translate(-50%, -50%);
                -moz-transform: translate(-50%, -50%);
                -ms-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
                left: 50%;
                top: 50%;
            }
        }

        #center_circle {
            display: flex;
            flex-direction: column;
            padding-top: 8.5px;
            padding-left: 25.5px;
            box-sizing: border-box;
            // justify-content: center;

            &>div {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;

                .center_circle_name {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    em {
                        width: 11px;
                        height: 11px;
                        border-radius: 50%;
                        overflow: hidden;
                        margin-right: 6px;
                        display: block;
                    }

                    span {
                        font-size: 14px;
                        line-height: 20px;
                        color: #484848;
                    }
                }

                .center_circle_rate {
                    padding-right: 23px;
                    box-sizing: border-box;

                    span {
                        font-size: 14px;
                        line-height: 20px;
                        color: #484848;
                    }
                }
            }
        }
    }

    .openApp {
        width: 100%;
        height: auto;
        width: 100%;
        padding: 22.5px 14px 12px;
        background-color: #fff;
        box-sizing: border-box;

        button {
            width: 100%;
            height: 45px;
            border: 0.5px solid #FE484A;
            border-radius: 22.5px;
            background-color: #fff;
            font-size: 15px;
            color: #FE484A;
        }
    }

    // 最近调仓
    .warehouse {
        width: 100%;
        height: auto;
        background-color: #fff;
        margin-top: 6px;

        .warehouse_head {
            width: 100%;
            height: 42.5px;
            border-bottom: 0.5px solid #EBEBEB;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 12px;

            .warehouse_head_left {

                .warehouse_head_left_title {
                    font-size: 15px;
                    line-height: 18px;
                    color: #333333;
                    margin-right: 6px;
                }

                .warehouse_head_left_time {
                    font-size: 13px;
                    line-height: 18px;
                    color: #939393;
                }
            }

            .warehouse_head_right {

                button {
                    font-size: 14px;
                    line-height: 18px;
                    color: #636363;
                    background-color: transparent;
                    background-image: url("https://cdncos.aigupiao.com/assets/wap/img/hsReplicaProfits/right_arrow.png");
                    background-repeat: no-repeat;
                    background-position: right center;
                    background-size: 9px 13.5px;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    padding: 0 14px 0 0;
                }
            }
        }

        .businessList_header {
            width: 100%;
            height: 43px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 14px 0 12px;
            box-sizing: border-box;
            border-bottom: 1px solid #EBEBEB;

            div {
                font-size: 13px;
                color: #333333;
                flex: 3;

                &:nth-child(1) {
                    flex: 4;
                }

                &:nth-child(2) {
                    flex: 2;
                }

                &:nth-child(3) {
                    text-align: right;
                }
            }
        }

        .businessList_box {
            display: flex;
            flex-direction: column;

            .businessList_li {
                width: 100%;
                height: auto;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                border-bottom: 0.5px solid #EBEBEB;
                padding: 10px 12px 5.5px 10px;
                box-sizing: border-box;

                .businessList_l {
                    flex: 4;
                    display: flex;

                    .businessList_l_type {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 7px;

                        span {
                            width: 20px;
                            height: 20px;
                            line-height: 20px;
                            text-align: center;
                            display: block;
                            border-radius: 50%;
                            overflow: hidden;
                            color: #FEFFFE;
                            font-size: 12px;

                            &.up {
                                background-color: #FE484A;
                            }

                            &.down {
                                background-color: #0AC890;
                            }
                        }
                    }

                    .businessList_l_nc {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: flex-start;

                        .businessList_l_name {
                            font-size: 14px;
                            line-height: 17px;
                            color: #333333;
                            font-weight: bold;
                            margin-bottom: 2px;
                        }

                        .businessList_l_code {
                            font-size: 12px;
                            line-height: 16.5px;
                            color: #9F9F9F;
                        }
                    }
                }

                .businessList_c {
                    flex: 2;

                    .businessList_c_c {
                        font-size: 14px;
                        font-weight: bold;
                        line-height: 20px;

                        &.up {
                            color: #FE484A;
                        }

                        &.down {
                            color: #0AC890;
                        }
                    }

                    .businessList_c_a {
                        font-size: 12px;
                        line-height: 16.5px;
                        color: #9F9F9F;
                    }
                }

                .businessList_r {
                    flex: 3;

                    .businessList_r_c {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        margin-bottom: 1px;

                        em {
                            width: 16.5px;
                            height: 5px;
                            background-image: url("https://cdncos.aigupiao.com/assets/wap/img/hsReplicaProfits/arrow.png");
                            background-size: 16.5px 6px;
                            background-repeat: no-repeat;
                            background-position: center center;
                            display: inline-block;
                            transform: translateY(-2px);
                            margin: 0 2px;
                        }

                        span {
                            font-size: 14px;
                            line-height: 20px;
                            color: #333333;
                        }
                    }

                    .businessList_r_t {
                        text-align: right;
                        font-size: 12px;
                        line-height: 16.5px;
                        color: #9F9F9F;
                    }
                }
            }
        }
    }

    // 组合讨论
    .discuss {
        width: 100%;
        height: auto;
        background-color: #fff;
        margin-top: 6px;

        .discuss_head {
            width: 100%;
            height: 42.5px;
            border-bottom: 0.5px solid #EBEBEB;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 12px;

            .discuss_head_left {

                .discuss_head_left_title {
                    font-size: 15px;
                    line-height: 18px;
                    color: #333333;
                    margin-right: 6px;
                }
            }
        }

        &>div {
            padding-top: 11px;

            .first_level_comment {
                border-bottom: none;
                padding: 10px 10px 0 12px;
                list-style: none;
                display: flex;
                padding-bottom: 0;
                width: 100%;
                box-sizing: border-box;

                &>a {
                    height: 50px;

                    img {
                        width: 32px;
                        height: 32px;
                        margin: 4px 8.5px 0 0;
                        border-radius: 50%;
                    }
                }
                
                .live_comment_right {
                    flex: 1;
                    position: relative;

                    p {
                        span {
                            color: #222;
                            display: inline;

                            &.comment_uName {
                                font-size: 15px !important;
                            }
                        }

                        a.secLev_uLink {
                            color: #999;
                            display: inline-block;
                        }
                    }
                    
                    .comment_detail {

                        p {
                            width: auto;
                            margin: 0;

                            span {
                                float: left;
                            }                            
                        }

                        .comment_reply_wrap {

                            a.yizan i {
                                background: url(https://cdn.aigupiao.com/static/wap/img/Popularize/liked.png) no-repeat;
                                background-size: 100% 100%;
                            }
                            
                            i {
                                float: left;
                                width: 14px;
                                height: 14px;
                                background: url(https://cdn.aigupiao.com/static/wap/img/Popularize/like.png) no-repeat;
                                background-size: 100% 100%;
                                vertical-align: middle;
                                margin-top: 0px;

                                
                            }
                            .comment_reply {
                                float: left;
                                color: #636363;
                                height: 16px;
                                cursor: pointer;

                                &::hover {
                                    color: #ed4040;
                                }
                            }
                        }
                    }

                }
            }
        }
    }
}
.bottom-banner-container{
    background-image:url("https://cdn.aigupiao.com/static/wrap/img/lives_download_bottom_bg.png");height:48px;background-size:cover;position:relative;margin-top: 0.2rem;
}
.bottom-banner-container .bottom-banner-content {display: block;position: absolute;bottom: 0;padding: 0 30px 8px 15px;-webkit-box-sizing: border-box;box-sizing: border-box;width: 100%;display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-orient: horizontal;-webkit-box-direction: normal;-ms-flex-direction: row;flex-direction: row;-webkit-box-pack: start;-ms-flex-pack: start;justify-content: flex-start;-webkit-box-align: center;-ms-flex-align: center;align-items: center;}
.bottom-banner-container .bottom-banner-content.noBonus{-webkit-box-pack: justify;-ms-flex-pack: justify;justify-content: space-between;}
.bottom-banner-container .bottom-banner-content .line {
    width: 1px;
    height: 7px;
    -webkit-transform: rotate(10deg);
    transform: rotate(10deg);
    background-color: #ffffff;
    display: inline-block;
    margin: 0 6px;
}
.bottom-banner-container .bottom-banner-content .title {
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    display: inline-block;
}
.bottom-banner-container .bottom-banner-content .see-comments {
    opacity: .7;
    font-size: 11px;
    color: #ffffff;
}

.bottom-banner-container .bottom-banner-content .download-btn {
    margin-left: 10px;
    font-size: 13px;
    width: 70px;
    height: 24px;
    border-radius: 12px;
    line-height: 24px;
    display: inline-block;
    text-align: center;
    color: #ff5050;
    font-weight: 500;
    background-color: #fff;
}
.bottom-banner-container .bottom-banner-content.noBonus .download-btn img {
    position: relative;
    top: -2px;
}
.bottom-banner-container .bottom-banner-content .download-btn img {
    height: 8px;
    vertical-align: middle;
    padding-left: 5px;
}
</style>

<style>
.chart_info span {
    font-size: 12px;
    line-height: 16.5px;
    color: #636363;
    margin-bottom: 1.5px;
}

.chart_info p {
    font-size: 17px;
    line-height: 24px;
    color: #333333;
    font-weight: bold;
}
.second_level_comment a img {
    width: .2rem;
    height: .4rem;
    margin: .08rem .2rem .6rem 0;
    border-radius: 50%;
}
.comment_reply_wrap,
.status_public {
    width: 100%;
    float: left;
}

.comment_con {
    font-size: 15px !important;
    display: inline-block;
}

.comment_detail span,
.second_level_info div span {
    vertical-align: middle
}

.AGP_face {
    width: 15px;
    vertical-align: sub;
}
.comment_detail_info .AGP_face {
    width: 20px;
}

/*.second_level_info div span,.comment_detail_info p{display:block;}*/
.comment_detail_info {
    width: 100%;
    float: left;
    padding: 4px 0 0 0;
    line-height: 20px;
    margin-bottom: 10px;
}

.second_level_info {
    font-size: 13px;
    line-height: 19px;
}

.first_level_comment .comment_point {
    float: none;
    position: absolute;
    right: 0;
    top: 0
}

.second_level_wrap {
    border-radius: 10px;
    background: #F8F8F8;
    padding: 8px 13px;
}

.second_level_wrap li {
    padding: 0;
    border-top: none;
    margin-bottom: 7px;
}

.second_level_wrap li.third_level_comment {
    width: 610px;
    border-bottom: 1px dashed #dcdcdc;
    padding: 4px 0;
    margin-left: 58px;
    background: #f0f0f0;
}

.second_level_comment {
    width: 100%;
    padding-left: 15px;
    display: block;
}
.second_level_comment:last-of-type {
    margin-bottom: 3px !important;
}
.second_level_info {
    float: none;
    flex: 1;
    width: 100%;
}
.second_level_info>p {
    float: none;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
}

.second_level_comment>.comment_expand_full {
    float: none;
    width: 100%;
}

.second_level_reply,
.third_level_reply {
    float: right;
    display: none;
}

.second_level_reply textarea {
    width: 610px;
    float: right;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px;
}

.third_level_reply textarea {
    width: 100%;
    float: right;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px;
}

.second_level_reply .v2_faceBtn,
.third_level_reply .v2_faceBtn {
    float: left;
    width: 60px;
    height: auto;
    border-radius: unset;
    background: unset;
    font: 12px/30px "微软雅黑";
    color: #fff;
    text-align: center;
    margin: 0
}

.second_level_reply a,
.third_level_reply a {
    margin: 0;
}

.third_level_reply textarea {
    width: 100%;
}

.comment_reply_wrap .recommend_btn {
    float: left;
    color: #999;
    margin-left: 25px;
}

.second_level_reply .comment_disable,
.third_level_reply .comment_disable {
    background: #BFBFBF;
    border-color: #bfbfbf;
}

.comment_reply_wrap .recommend_btn {
    float: left;
    color: #999;
    margin-left: 25px;
}

.comment_point span {
    margin: 0 4px;
    color: #999;
    line-height: 16px;
}

.first_level_comment a.yizan span {
    color: #f04748;
    font-weight: bold;
}

.second_level_comment a.yizan span {
    color: #f04748;
    font-weight: bold;
}


.first_level_comment a.yizan span {
    color: #f04748;
}

/*.comment_reply_wrap .click_like{background-position:-51px -18px;}*/
.exp_content .ex_lang_show {
    display: none;
}

body {
    position: relative;
}
.commentMask {
    display: none;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
}
.comment_expand_full {
    width: 100%;
    float: left;
}
.comment_expand_full span {
    color: #939393;
    font-size: 15px;
    height: 20px;
    display: inline-block;
}
.second_level_comment .comment_expand_full {
    display: flex;
    align-items: center;
}
.second_level_comment .comment_expand_full span {
    color: #4B78B2;
    font-size: 12px;
    line-height: 18px;
}
.second_level_comment .comment_expand_full i {
    display: inline-block;
    width: 9px;
    height: 5px;
    margin-left: 5px;
    background: url(https://cdncos.aigupiao.com/assets/pc/img/icon-w-comment-down.png) no-repeat;
    background-size: cover;
}
.second_level_comment .comment_expand_full i.up_i {
    background: url(https://cdncos.aigupiao.com/assets/pc/img/icon-w-comment-up.png) no-repeat;
    background-size: cover;
}
.cmtMask_n,
.subcmtMask {
    width: 100%;
    height: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 9999;
}
.comment_wrap {
    width: 100%;
    background: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 10px;
    box-sizing: border-box;
    margin: 0
}
.comment_publish a,
.cancel-fb {
    width: 70px;
    height: 28px;
    float: right;
    background: #fe484a;
    border: 1px solid #fe484a;
    border-radius: 3px;
    color: #fff;
    text-align: center;
    line-height: 30px;
    display: inline-block;
    font-size: 15px;
}
.cancel-fb {
    background: #fe484a;
    border: 1px solid #B7B7B7;
    background: #fff;
    margin-right: 10px;
    color: #939393;
}
.comment_wrap textarea {
    width: 100%;
    height: 100px;
    display: block;
    padding: 6.5px;
    border-radius: 3px;
    outline: none;
    overflow-y: auto;
    overflow-x: hidden;
    resize: none;
    font-size: 15px !important;
    border: 1px solid #e2e2e2;
    box-sizing: border-box
}
.comment_wrap .bd {
    position: relative;
    margin-bottom: 6.5px;
}
.comment_wrap .textnum {
    width: 6.5px;
    height: 16px;
    background: #f7f7f7;
    text-align: center;
    line-height: 16px;
    display: inline-block;
    font-size: 15px;
    position: absolute;
    bottom: 13px;
    right: 13px;
    color: #767676;
    border-radius: 3px;
}
.comment_wrap .textnum span {
    font-size: 15px;
    line-height: 17px;
}
.comment_wrap .hd {
    color: #646464;
    font-weight: 400;
    margin-bottom: 13px;
    font-size: 12px;
}
.comment_wrap .cancel-fb {
    float: right;
    font-style: normal;
    cursor: pointer
}
.comment_publish {
    height: auto;
    padding: 10px 0em;
}
.comment_detail span,
.comment_detail p span,
.comment_detail a,
.second_level_info div span {
    font-size: 12px;
}
.comment_con_1 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
}
.commentLikeS {
    display: inline-block;
    height: 14px;
    float: left
}
.m_bg{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    bottom: 0;
    left: 0;
} 
.m_bg .comment_con_1{
    display: block;
    overflow: unset;
}
.m_box{   
    position: absolute;bottom: 0;left: 0;width: 100%;max-height: 80%;background: #FFFFFF;
    border-radius: 20px 20px 0px 0px;
    overflow: auto;
    height: 80%;
    display:none;
}
.m_hea{
    height: 50px;
    border-bottom: 1px solid #f2f2f2;
    position: relative;
    display: flex;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fff;
    border-radius: 20px 20px 0px 0px;
}
.m_hea_t{
    flex: 1 1;
    text-align: center;
    color: #222;
    font-size: 15px;
}
.m_close{
    background: url(https://cdncos.aigupiao.com/assets/wap/img/close.png);
    width: 16.25px;
    height: 16.25px;
    background-size: cover;
    position: relative;
    left: 26px;
}
.reply-split-content{
    color: #222;
    font-size: 16px;
    font-weight: 500;
    padding: 15px 13px;
    border-top: 1px solid #f2f2f2;  
}
.activate-modal-container{  
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    background: rgba(0,0,0,.6);
}
.activate-modal{
    background-color: #fff;
    border-radius: 10.4px;
}
.activate-modal .text{
    padding: 26px 20px;
    font-size: 14px;
    line-height: 31px;
    text-align: left;
    box-sizing: border-box;
color: #333333;}
.button-group{
    display: flex;
    border-top: 1px solid #E0E0E0;
}
.button-group >div{
    width: 50%;
    text-align: center;
    font-size: 16px; 
    padding: 14.95px 0; 
    color: #636363;
    margin-top: 0;
}
.button-group .confirm{
    border-left: 1px solid #E0E0E0;
    color: #FE484A;
}


/*评论部分样式*/
.exp_comment_list{}
.live_comment_top{}
.user_login_info{float:left;}
.live_comment_top img{width:34px;height:34px;border-radius:50%;float:left;margin-right:10px;}
/*.live_comment_top span{font:14px/34px "微软雅黑";color:#666;float:left;}*/
.live_comment_box{padding:0 30px;}
.live_comment_wrap textarea,.news_comment_wrap textarea{height:20px;padding: 13px; width:6.52rem;border:1px solid #e2e2e2;font-size:18.2px;border-radius:4px;resize:none;outline:none;margin-top: 0px;}
.live_hot_comment,.live_comment_info{height:29px;border-bottom:1px solid #ececec;font:16px/16px "微软雅黑";color:#666;padding-top:20px;font-weight:bold;}
.live_hot_comment span .live_comment_info .live_comment_all span,.live_comment_info .live_comment_teacher span{font-size:14px;color:#999;}
.no_comment{width:100%;font:14px/20px "微软雅黑";color:#999;text-align:center;padding:60px 0 10px 0;display:none;}
.first_level_comment{border-bottom:none;padding: 13px;list-style:none; display: flex; padding-bottom: 0; width: 100%; box-sizing: border-box;}
.first_level_comment a img{width:32px;height:32px;margin: 5.2px 9.75px 39px 0;border-radius:50%;}
.second_level_comment a img,.third_level_comment a img{width: 13px;height: 26px;margin: 5.2px 13px 39px 0;border-radius:50%;}
.live_comment_right{flex:1;position: relative;}
.live_comment_right p span{ color:#222;display:inline;}
.live_comment_right p a.secLev_uLink{ color:#999;display:inline-block;}
.comment_detail p span{float:left;}
.comment_detail p{width:auto;margin:0;}
.comment_reply_wrap,.status_public{width:100%;float:left;/*margin:6px 0;*/}
/*.comment_reply_wrap i{float:left;width:16px;height:16px;background:url(https://cdn.aigupiao.com/static/pc/img/lives/comment_like.png) no-repeat;margin-top:3px;background-size:cover;}*/
.comment_reply_wrap i{float:left;width: 14px;height: 14px; background:url(https://cdn.aigupiao.com/static/wap/img/Popularize/like.png) no-repeat;
    background-size: 100% 100%; vertical-align: middle;margin-top: 0px; }
.t_c_name{font-size: 12px;color: #4B78B2}
.comt_box{font-size: 12px; position: relative}
.comment_uName{font-size: 15px!important; }
.comment_con{font-size: 15px!important; display:inline-block;}
.comment_detail span,.second_level_info div span{ vertical-align: middle}
/*.second_level_info div span,.comment_detail_info p{display:block;}*/
.comment_detail_info{width: 100%; float:left;    padding: 4px 0 0 0;line-height: 20px;margin-bottom: 10px;}
.second_level_info{font-size: 13px;line-height: 19px;}

.comment_reply_wrap .comment_reply{float:left;color:#636363; height:16px }
.comment_reply_wrap .comment_reply:hover{color:#ed4040;}
.first_level_comment .comment_point{float:none; position: absolute;    right: 0; top:0}
.second_level_wrap{ border-radius: 10px; background: #F8F8F8; padding:8px 13px;}
.second_level_wrap.show_tab  {display: block;}
.second_level_wrap li{padding: 0; border-top: none; margin-bottom: 7px;}
.second_level_wrap li.third_level_comment{width:610px;border-bottom:1px dashed #dcdcdc;padding:4px 0;margin-left:58px;background: #f0f0f0;}
.second_level_wrap li a img{}
.second_level_comment{width:100%;padding-left:15px;display:block;}
.second_level_comment:last-of-type{margin-bottom: 3px !important;}
.second_level_info{float:none;flex:1;width:100%;
    /*margin-bottom: 4px;*/
}
.second_level_info > p{
    float:none;
    width:100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
}
.second_level_comment > .comment_expand_full{float:none;width:100%;}
.third_level_reply textarea{width:100%;float:right;box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px;}
.second_level_reply .v2_faceBtn,.third_level_reply .v2_faceBtn{float:left;width:60px;height:auto;border-radius:unset;background:unset;font:12px/30px "微软雅黑";color:#fff;text-align:center;margin: 0}
.second_level_reply a,.third_level_reply a{margin:0;}
.third_level_reply textarea{width:100%;}
.comment_reply_wrap .recommend_btn{float:left;color:#999;margin-left:25px;}
.second_level_reply .comment_disable,.third_level_reply .comment_disable{background:#BFBFBF;}
.comment_reply_wrap .recommend_btn{float:left;color:#999;margin-left:25px;}
.comment_point span{margin:0 4px;color:#999;}
.dl_app {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: rgba(254,72,74,1);
    border-radius: 4px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    display: inline-block;
    margin: 20px auto 0 auto;
}

.comment_reply_wrap a.yizan i {
    background: url(https://cdn.aigupiao.com/static/wap/img/Popularize/liked.png) no-repeat;
    background-size: 100% 100%;
}
</style>